import Getit from './Getit';
import logo from './logo.svg';
import SiteMap from "./SiteMap";
import Voyager from "./Voyager";
import Help from './Voyager/help';
import PrivacyPolicy from "./Voyager/Privacy-Policy";
import GetitPrivacyPolicy from "./Getit/Privacy-Policy";

const routes = [
    {
        path: "/",
        element: <div className="App">
            <header className="App-header">
                <img src={logo} className="App-logo" alt="logo" />
            </header>
        </div>,
    },
    {
        path: "/voyager",
        children: [
            {
                path: "",
                element: <Voyager />
            },
            {
                path: "*",
                element: <Voyager />
            },
            {
                path: "privacy-policy",
                element: <PrivacyPolicy />
            },
            {
                path: "help",
                element: <Help />
            }
        ]
    },
    {
        path: "/getit",
        children: [
            {
                path: "",
                element: <Getit />
            },
            {
                path: "*",
                element: <Getit />
            },
            {
                path: "privacy-policy",
                element: <GetitPrivacyPolicy />
            },
        ]
    },
    {
        path: "*",
        element: <SiteMap />,
    },
]
export default routes;